import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="host" id="host"></a>
    <h1 {...{
      "id": "requireuxphost"
    }}>{`require('uxp').host`}</h1>
    <p>{`Includes useful information about the operating environment the plugin finds itself executing in.
`}<inlineCode parentName="p">{`require("uxp").host`}</inlineCode></p>
    <a name="host-name" id="host-name"></a>
    <h2 {...{
      "id": "name--string"
    }}>{`name ⇒ `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - name of the host application. For ex, returns "photoshop" for Photoshop  `}</p>
    <a name="host-version" id="host-version"></a>
    <h2 {...{
      "id": "version--string"
    }}>{`version ⇒ `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - version of host application. For ex, "20.0.0"  `}</p>
    <a name="host-uilocale" id="host-uilocale"></a>
    <h2 {...{
      "id": "uilocale--string"
    }}>{`uiLocale ⇒ `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - 5 letter UI locale of host application. For ex, "en_US"  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      